import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

export function BackToTop() {
  const { lang } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[55] group flex items-center gap-2 pl-3 pr-4 py-2.5 bg-primary text-primary-foreground shadow-xl shadow-primary/20 hover:bg-brandgreen transition-colors duration-300 active:scale-95"
          data-testid="back-to-top"
          aria-label={lang === "es" ? "Volver arriba" : "Back to top"}
        >
          <ArrowUp size={16} className="group-hover:-translate-y-0.5 transition-transform duration-300" />
          <span className="label-caps text-[0.62rem]">{lang === "es" ? "Arriba" : "Top"}</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
